<script setup>
import { ref } from 'vue';
import SettingsSubPageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Input from 'dashboard/components-next/input/Input.vue';
import microsoftChannelClient from 'dashboard/api/channel/microsoftChannelClient';

import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

const { t } = useI18n();

const email = ref('');
const isRequestingAuthorization = ref(false);

async function requestAuthorization() {
  try {
    isRequestingAuthorization.value = true;
    const response = await microsoftChannelClient.create({
      email: email.value,
    });

    const {
      data: { url },
    } = response;
    window.location.href = url;
  } catch (error) {
    useAlert(t('INBOX_MGMT.ADD.MICROSOFT_CHANNEL.ERROR_MESSAGE'));
  } finally {
    isRequestingAuthorization.value = false;
  }
}
</script>

<template>
  <div
    class="border border-n-weak bg-n-solid-1 rounded-t-lg border-b-0 h-full w-full p-6 col-span-6 overflow-auto"
  >
    <SettingsSubPageHeader
      :header-title="$t('INBOX_MGMT.ADD.MICROSOFT_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.MICROSOFT_CHANNEL.DESCRIPTION')"
    />
    <form class="mt-6" @submit.prevent="requestAuthorization">
      <Input
        v-model="email"
        type="email"
        :placeholder="$t('INBOX_MGMT.ADD.MICROSOFT_CHANNEL.EMAIL_PLACEHOLDER')"
        required
      />
      <NextButton
        :is-loading="isRequestingAuthorization"
        class="mt-4"
        :label="$t('INBOX_MGMT.ADD.MICROSOFT_CHANNEL.SIGN_IN')"
      />
    </form>
  </div>
</template>
